export function onEdit(service) {
  this.setState({isModalOpen: true, editService: service});
}
